import * as commonGraphql from 'graphql/common.graphql'
import { api, REQUEST_TYPE } from 'store/api'
import { ModuleTags } from './consts'
import { practiceGuidelinesByDoctorIdSorted } from 'graphql/customQueries'

const needsAttentionPatientFields = `
  id
  program
  statusKey
  name
  profilePicture {
    key
    bucket
    region
  }
  patientTags {
    items {
      _deleted
      createdAt
      metadata
      tag {
        value
      }
    }
  }
`

const mapPatientTagToNeedsAttentionData = patientTag => {
  const { metadata, createdAt } = patientTag
  const { reason, note, selectedPracticeMembersIds } = JSON.parse(metadata || '{}')

  return {
    createdAt,
    reason,
    note,
    selectedPracticeMembersIds
  }
}

export const CopilotControl = api.injectEndpoints({
  endpoints: build => ({
    fetchCopilotMetabaseData: build.query({
      query: ({ accountOwnerId, pastXDays }) => ({
        type: REQUEST_TYPE.GET,
        path: `/copilot/v1/practices/${accountOwnerId}`,
        queryParams: {
          pastXDays
        }
      }),
      providesTags: [ModuleTags.CopilotControlMetabase]
    }),
    fetchNeedsAttentionPatients: build.query({
      query: ({ accountOwnerId }) => ({
        type: REQUEST_TYPE.GRAPHQL_FETCH_ALL,
        query: commonGraphql.searchPatientSearchModels(needsAttentionPatientFields),
        queryName: 'searchPatientSearchModels',
        variables: {
          limit: 100,
          filter: {
            doctorId: { eq: accountOwnerId },
            tagKeywords: {
              eq: 'needsAttention'
            }
          }
        }
      }),
      transformResponse: res => ({
        items: (res || []).map(psm => {
          const needsAttentionTag = psm.patientTags.items.find(
            patientTag => patientTag.tag?.value === 'needsAttention' && !patientTag._deleted
          )
          return {
            ...psm,
            needsAttentionData: needsAttentionTag ? mapPatientTagToNeedsAttentionData(needsAttentionTag) : null
          }
        })
      })
    }),
    fetchLatestPracticeGuidelines: build.query({
      query: ({ accountOwnerId }) => ({
        type: REQUEST_TYPE.GRAPHQL,
        query: practiceGuidelinesByDoctorIdSorted,
        variables: {
          sortDirection: 'DESC',
          limit: 1,
          doctorId: accountOwnerId
        }
      }),
      transformResponse: res => res.practiceGuidelinesByDoctorIdSorted?.items[0],
      providesTags: [ModuleTags.PracticeGuidelines]
    })
  })
})

export const {
  useFetchCopilotMetabaseDataQuery,
  useFetchNeedsAttentionPatientsQuery,
  useFetchLatestPracticeGuidelinesQuery
} = CopilotControl
